// project import
import contacts from './contacts';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [contacts]
};

export default menuItems;
